export default "__VITE_ASSET__CT$hVhDa__"